import { authHttp } from '../http'
import * as routes from '../../routes/system.routes'
import {
  urlGetPermissions,
  urlGetTiposArquivoPorEmpresa,
  urlGetTiposArquivos,
  urlGetUsersActions,
  urlPickingsProntosParaDownload,
  urlPostTipoArquivo,
  urlPutHandleAssocTiposArquivoEmpresa,
  urlToggleGroupPermissions,
  urlUserAction,
  urlUserActionGroup,
} from '../../routes/system.routes'
import { errorHandler } from '../../../util/error.service'
import { CONFIG } from '../../../../config'

export async function getUfs() {
  try {
    const response = await authHttp().get(routes.urlUfs)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCities(uf_id) {
  try {
    const response = await authHttp().get(routes.urlCities(uf_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveClientsMassively(clients, file_type_id, tpId, associarAoTp) {
  try {
    const response = await authHttp().post(
      routes.urlMassiveClientsInserts(file_type_id, tpId, associarAoTp),
      clients,
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveProductsMassively(products) {
  try {
    const response = await authHttp().post(routes.urlMassiveProductsInserts, products)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveDriversMassively(drivers) {
  try {
    const response = await authHttp().post(routes.urlMassiveDriversInserts, drivers)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveVehiclesMassively(vehicles) {
  try {
    const response = await authHttp().post(routes.urlMassiveVehiclesInserts, vehicles)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveClienteRotaMassively(tp_id, clienteRota) {
  try {
    const response = await authHttp().post(
      routes.urlMassiveClientsRoutesInserts(tp_id),
      clienteRota,
    )

    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveProductsEanMassively(products) {
  try {
    const response = await authHttp().post(routes.urlMassiveProductsEanInserts, products)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveStepsMassively(trechos) {
  try {
    const response = await authHttp().post(routes.urlMassiveClientStepInserts, trechos)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveAssocClienteEmpresa(associacoes) {
  try {
    const response = await authHttp().post(routes.urlMassiveAssocClientCompany, associacoes)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Celular App Expedicao
export async function salvarCelularAppExpedicao({
  id,
  codigo_ativacao,
  ativado,
  data_ativacao,
  habilitado,
  tp_id,
}) {
  try {
    let response
    if (id) {
      response = await authHttp().put(routes.urlPostNovoCelular, {
        id,
        codigo_ativacao,
        ativado,
        data_ativacao,
        habilitado,
        tp_id,
      })
    } else {
      response = await authHttp().post(routes.urlPostNovoCelular, {
        codigo_ativacao,
        ativado,
        data_ativacao,
        habilitado,
        tp_id,
      })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCelularesAppExpedicao(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetCelulares(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCelularesAppExpedicaoByEmail(tp_id, email) {
  try {
    const response = await authHttp().get(routes.urlGetCelularesByEmail(tp_id, email))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getUsuariosAssocCelularAppExpedicao(celular_id) {
  try {
    const response = await authHttp().get(routes.urlGetUsuariosCelularAppExpedicao(celular_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function toggleUsuarioAutorizado(assoc_id, autorizado) {
  try {
    const response = await authHttp().put(routes.urlToggleUsuarioAutorizado, {
      assoc_id,
      autorizado,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function toggleUsuarioFinalizaPicking(assoc_id, finaliza_picking) {
  try {
    const response = await authHttp().put(routes.urlToggleUsuarioFinalizaPicking, {
      assoc_id,
      finaliza_picking,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function toggleUsuarioConfiguraPicking(assoc_id, configura_picking) {
  try {
    const response = await authHttp().put(routes.urlToggleUsuarioConfiguraPicking, {
      assoc_id,
      configura_picking,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function toggleUsuarioConfiguraReconferenciaEtiqueta(assoc_id, configura_reconferencia_etiqueta) {
  try {
    const response = await authHttp().put(routes.urlToggleUsuarioConfiguraReconferenciaEtiqueta, {
      assoc_id,
      configura_reconferencia_etiqueta,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getUsuariosByCelularesAppExpedicao(celular_ids) {
  try {
    const response = await authHttp().post(routes.urlGetUsuariosByCelularesAppExpedicao, {
      celular_ids,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function salvarAssociacaoMassaConfigsAppExpedicao({
  user_id,
  celular_ids,
  finaliza_picking,
  configura_picking,
  configura_reconferencia_etiqueta,
}) {
  try {
    const response = await authHttp().put(routes.urlAssociacaoMassaConfigsAppExpedicao, {
      user_id,
      celular_ids,
      finaliza_picking,
      configura_picking,
      configura_reconferencia_etiqueta,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// Celular App Tp Drive

// O código de ativação do TP Drive não passa pelo portal: só se altera o "habilitado"
export async function updateCelularTpDrive({ id, habilitado }) {
  try {
    const response = await authHttp().put(routes.urlPutCelularTpDrive, {
      id,
      habilitado,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCelularesAppTpDrive(tp_id) {
  try {
    const response = await authHttp().get(routes.urlGetCelularesTpDrive(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function toggleUsuarioAutorizadoTpDrive(assoc_id, autorizado) {
  try {
    const response = await authHttp().put(routes.urlToggleUsuarioAutorizadoTpDrive, {
      assoc_id,
      autorizado,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function desassociarUsuarioTpDrive(assoc_id) {
  try {
    const response = await authHttp().delete(routes.urlDesassociarUsuarioTpDrive(assoc_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** User Actions Group *****
export async function saveUserActionGroup(name) {
  try {
    const response = await authHttp().post(urlUserActionGroup, { name })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getUserActionGroups() {
  try {
    const response = await authHttp().get(urlUserActionGroup)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** User Action *****
export async function saveUserAction({ id, action, action_group_id, show_ordem }) {
  try {
    let response
    if (id) {
      response = await authHttp().put(urlUserAction, { id, action, action_group_id, show_ordem })
    } else {
      response = await authHttp().post(urlUserAction, { action, action_group_id, show_ordem })
    }
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getUsersActions() {
  try {
    const response = await authHttp().get(urlGetUsersActions)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** User Group Permission *****
export async function getGroupPermission(group_id) {
  try {
    const response = await authHttp().get(urlGetPermissions(group_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function toggleGroupPermissions(group_id, user_action_id) {
  try {
    const response = await authHttp().post(urlToggleGroupPermissions(group_id, user_action_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** Tipos de Arquivos de Importação *****
export async function getTiposDeArquivosDeImportacao() {
  try {
    const response = await authHttp().get(urlGetTiposArquivos)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getTiposDeArquivosDeImportacaoByIds(ids) {
  try {
    const response = await authHttp().get(routes.urlGetTiposArquivosByIds(ids))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function saveTipoDeArquivoDeImportacao(tipo) {
  try {
    const response = await authHttp().post(urlPostTipoArquivo, tipo)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function uploadModeloImportacao(tipoId, name, file) {
  try {
    const formData = new FormData()
    formData.append('modelo', file)
    const response = await authHttp().post(
      routes.urlUploadModeloImportacao(tipoId, name),
      formData,
      {
        headers: { 'Content-Type': 'multipart/form-data' },
      },
    )
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function downloadModeloImportacao(filename) {
  try {
    const response = await authHttp().get(routes.urlModeloImportacao(filename), {
      responseType: 'blob',
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteModeloImportacao(filename) {
  try {
    const response = await authHttp().delete(routes.urlModeloImportacao(filename))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ***** Associação Empresa com Tipos de Arquivos de Importação *****
export async function getAssocTiposArquivoComEmpresa(company_id) {
  try {
    const response = await authHttp().get(urlGetTiposArquivoPorEmpresa(company_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function handleAssocTiposArquivoComEmpresa(company_id, file_type_id, action, value) {
  try {
    const response = await authHttp().put(urlPutHandleAssocTiposArquivoEmpresa, {
      company_id,
      file_type_id,
      action,
      value,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Gerar Arquivo de Separação - Emergencial ***** //
export async function getPickingsProntosParaDownload(tp_id) {
  try {
    const response = await authHttp().get(urlPickingsProntosParaDownload(tp_id))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Associar User X Local de Movimentação ***** //
const { ENVIROMENT } = CONFIG
const PATRIMONIO_BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/patrimonio`
const INSUMO_BASE_URL = `${CONFIG[ENVIROMENT]['MAIN_END_POINT']}/insumo`

export async function getLocaisMovimentacaoByUser(userId) {
  try {
    const url = PATRIMONIO_BASE_URL + '/user-local-movimentacao/' + userId
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function associarUserLocalMovimentacao(associacao) {
  try {
    const url = PATRIMONIO_BASE_URL + '/user-local-movimentacao'
    const response = await authHttp().post(url, associacao)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Operações de Movimentação Patrimonial ***** //
export async function getOperacoesMovimentacaoPatrimonial() {
  try {
    const url = PATRIMONIO_BASE_URL + '/operacao-movimentacao-patrimonial'
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function salvarOperacaoMovimentacaoPatrimonial(operacao) {
  try {
    const url = PATRIMONIO_BASE_URL + '/operacao-movimentacao-patrimonial'
    const response = await authHttp().post(url, operacao)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Operações de Movimentação Insumo ***** //
export async function getOperacoesMovimentacaoInsumo() {
  try {
    const url = INSUMO_BASE_URL + '/operacao-movimentacao-insumo'
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function salvarOperacaoMovimentacaoInsumo(operacao) {
  try {
    const url = INSUMO_BASE_URL + '/operacao-movimentacao-insumo'
    const response = operacao.id
      ? await authHttp().put(url, operacao)
      : await authHttp().post(url, operacao)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Companies Group ***** //
export async function saveAssocCompanyGroup(companyGroup) {
  try {
    const url = routes.urlSaveAssocCompanyGroup
    const response = await authHttp().post(url, companyGroup)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCompaniesGroupsWithItems() {
  try {
    const url = routes.urlGetCompaniesGroupsWithItems
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCompaniesToAssocWithGroup() {
  try {
    const url = routes.urlGetCompaniesToAssocWithGroup
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCompaniesByUserId(userId) {
  try {
    const url = routes.urlGetCompaniesByUserId(userId)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function createCompanyGroup(data) {
  try {
    const url = routes.urlCreateCompanyGroup
    const response = await authHttp().post(url, data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function updateCompanyGroup(data) {
  try {
    const url = routes.urlUpdateCompanyGroup
    const response = await authHttp().put(url, data)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteCompanyGroup(dataId) {
  try {
    const url = routes.urlDeleteCompanyGroup(dataId)
    const response = await authHttp().delete(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCompaniesGroupAssociatedToUser(userId) {
  try {
    const url = routes.urlGetCompaniesGroupAssociatedToUser(userId)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function assocCompaniesGroupToUser(userId, assocIds) {
  try {
    const url = routes.urlAssocCompaniesGroupToUser(userId)
    const response = await authHttp().post(url, assocIds)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getClientsWithInconsistency() {
  try {
    const response = await authHttp().get(routes.urlGetClientsWithIncosistency())
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function deleteClientsWithInconsistencyFromList(clientId) {
  try {
    const response = await authHttp().delete(routes.urlGetClientsWithIncosistencyDelete(clientId))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCoordinates(endereco) {
  try {
    const response = await authHttp().get(routes.urlGetCoordinates(endereco))

    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getCnpjDataFocusNfe(cnpj) {
  try {
    const response = await authHttp().get(routes.urlGetCnpjDataFocusNfe(cnpj))
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

// ****** Alterar Status Picking ***** //

export async function changeStatusPickingToProntoParaDownload(pickingId, userId) {
  try {
    const url = routes.urlChangeStatusPickingToProntoParaDownload(pickingId, userId)
    const response = await authHttp().put(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function getSaldoMovimentacoesSaldoEstoque(tpId, companyId, productId, estoquesIds) {
  try {
    const url = routes.urlSaldoMovimentacoesSaldoEstoque(tpId, companyId, productId, estoquesIds)
    const response = await authHttp().get(url)
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}

export async function createMovimentacaoSaldoMovimentacoesSaldoEstoque(
  tpId,
  companyId,
  productId,
  estoquesIds,
  estoqueId,
  posicaoEstoqueId,
  operacaoEstoqueId,
  quantidade,
  dataMovimentacao,
) {
  try {
    const url = routes.urlCriarMovimentacaoSaldoMovimentacoesSaldoEstoque(tpId)
    const response = await authHttp().post(url, {
      company_id: companyId,
      product_id: productId,
      estoques_ids: estoquesIds,
      estoque_id: estoqueId,
      posicao_estoque_id: posicaoEstoqueId,
      operacao_estoque_id: operacaoEstoqueId,
      quantidade,
      data_movimentacao: dataMovimentacao,
    })
    return response.data
  } catch (error) {
    throw errorHandler(error)
  }
}
